import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_double');

    return (
        <div className="sp-220-double-B">
            <div className="pc features">
                <div className="t">
                    <div className="t-l box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_1.jpg'} alt={t('B_1_text')} />
                        <div className="box-text">
                            {t.rich('B_1_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                    <div className="t-m box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_2.jpg'} alt={t('B_2_text')} />
                        <div className="box-text">
                            {t.rich('B_2_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                    <div className="t-r box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_3.jpg'} alt={t('B_3_text')} />
                        <div className="box-text black">
                            {t.rich('B_3_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                </div>
                <div className="b">
                    <div className="b-l box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_4.jpg'} alt={t('B_4_text')} />
                        <div className="box-text">
                            {t.rich('B_4_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                    <div className="b-m box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_5.jpg'} alt={t('B_5_text')} />
                        <div className="box-text">
                            {t.rich('B_5_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                    <div className="b-r box">
                        <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_6.jpg'} alt={t('B_6_text')} />
                        <div className="box-text black">
                            {t.rich('B_6_text', {
                                s: (text: string) => <p className="small-text">{text}</p>,
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="h5 features">
                <div className="t box">
                    <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_1_768.jpg'} alt={t('B_1_text')} />
                    <div className="box-text">
                        {t.rich('B_1_text', {
                            s: (text: string) => <p className="small-text">{text}</p>,
                        })}
                    </div>
                </div>
                <div className="m">
                    <div className="m-l">
                        <div className="m-l-t box">
                            <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_2_768.jpg'} alt={t('B_5_text')} />
                            <div className="box-text">
                                {t.rich('B_5_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                        <div className="m-l-b box">
                            <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_3_768.jpg'} alt={t('B_2_text')} />
                            <div className="box-text">
                                {t.rich('B_2_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="m-r">
                        <div className="m-r-t box">
                            <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_4_768.jpg'} alt={t('B_4_text')} />
                            <div className="box-text">
                                {t.rich('B_4_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                        <div className="m-r-b box">
                            <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_5_768.jpg'} alt={t('B_3_text')} />
                            <div className="box-text black">
                                {t.rich('B_3_text', {
                                    s: (text: string) => <p className="small-text">{text}</p>,
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="b box">
                    <EFPicture src={'/responsive/picture/solar-panel-220w-double/2_6_768.jpg'} alt={t('B_6_text')} />
                    <div className="box-text black">
                        {t.rich('B_6_text', {
                            s: (text: string) => <p className="small-text">{text}</p>,
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
